import { render } from "./Button.vue?vue&type=template&id=3b0d61fe&ts=true"
import script from "./Button.vue?vue&type=script&setup=true&lang=ts"
export * from "./Button.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/Button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b0d61fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b0d61fe', __exports__)) {
    api.reload('3b0d61fe', __exports__)
  }
  
  module.hot.accept("./Button.vue?vue&type=template&id=3b0d61fe&ts=true", () => {
    api.rerender('3b0d61fe', render)
  })

}


export default __exports__